import { render, staticRenderFns } from "./stockout_detail.vue?vue&type=template&id=522e7217&scoped=true"
import script from "./stockout_detail.vue?vue&type=script&lang=js"
export * from "./stockout_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522e7217",
  null
  
)

export default component.exports